// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"e08ea5b1","671":"dc9752c7"}[chunkId] + ".chunk.js";
};